import { CloseCircleTwoTone } from '@ant-design/icons';
import { Dropdown, Tag } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useMemo, useState } from 'react';

import { createRenderByType, createRenderValueByType } from '@/components/TableFilters/components/Types';
import { useTableFilters } from '@/components/TableFilters/contexts/TableFiltersContext';
import { useTableGrid } from '@/contexts/tableGridContact';

import style from './index.less';

const FilterItem = ({ filter, t }) => {
  const { onRemoveActiveFilter, onChangeFilter, filtersValue } = useTableFilters();
  const { handleChangePage } = useTableGrid();
  const [visible, setVisible] = useState(false);
  //
  const currentFieldValue = filtersValue?.find((e) => filter.name === e?.name);
  const [currentValue, setCurrentValue] = useState(currentFieldValue?.value || false);
  //
  const onClose = useCallback(() => onRemoveActiveFilter(filter), [filter, onRemoveActiveFilter]);
  
  const applyFilter = useCallback((value) => {
    onChangeFilter({ value, name: filter.name });
    // reset page
    handleChangePage(1);
    setCurrentValue(value);
    setVisible(false);
  }, [filter.name, handleChangePage, onChangeFilter]);
  
  const renderComponent = useMemo(() => filter?.render || createRenderByType(filter?.type), [filter.render, filter.type]);
  const renderValue = useMemo(() => filter?.renderValue || createRenderValueByType(filter?.type), [filter.renderValue, filter.type]);
  
  const content = useMemo(() => renderComponent({
    filter,
    t,
    applyFilter,
    currentValue: currentValue?.filters?.map(e => e?.value) || null
  }), [applyFilter, currentValue, filter, renderComponent, t]);
  
  const eventContent = useMemo(() => (
    <Tag
      id={`tag-filter-${filter.name}`}
      className={classNames(style.tag, 'cursor-pointer flex items-center mx-1 w-fit my-1')}
      closable color="processing"
      onClose={onClose}
      closeIcon={<div className="text-xl leading-none ml-1"><CloseCircleTwoTone twoToneColor="#D9D9D9"/></div>}>
      <div className="flex flex-col md:flex-row">
        <div className="flex items-center py-1 w-max pr-2 font-semibold text-black">
          {t(filter.name)}:
        </div>
        <div className="flex items-center py-1">{renderValue({ filterValue: currentValue, t, filter })}</div>
      </div>
    </Tag>
  ), [currentValue, filter, onClose, renderValue, t]);
  
  return (
    <Dropdown
      className="font-normal"
      overlay={(
        <div
          className={classNames('min-w-48 bg-white rounded shadow border-solid border border-border-color', style.filterListContainer)}>{content}</div>
      )}
      onVisibleChange={setVisible}
      visible={visible}
      placement="bottomLeft"
      trigger={['click']}>
      {eventContent}
    </Dropdown>
  );
};

FilterItem.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  onChangeFilter: PropTypes.func,
};

export default memo(FilterItem);
